'use client';

import { useSearch } from '@/app/search-context';

export default function ActiveVideoTagsClient({ className, }: { className: string }) {
  const { selectedVideoTags, removeVideoTag, dataLoading, } = useSearch();

  if (dataLoading || selectedVideoTags.length === 0) {
    return <></>;
  }

  return (
    <div className={className}>
      {selectedVideoTags.map((tag, index) => {
        const parts = tag.split(`:`);
        return (
          <button
            onClick={() => removeVideoTag(tag)}
            key={index}
          >
            {`${parts[0]}${parts[1] ? ` - ${parts[1]}` : ``}`} &times;
          </button>
        );
      })}
    </div>
  );
}
